import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const LockIcon = observer('LockIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            className={className}
            height='20'
            onClick={onClick}
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask
                id='mask0_2397_28670'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='3'
                y='0'
                width='14'
                height='19'
            >
                <path
                    d='M5.00004 18.25C4.54171 18.25 4.14935 18.0868 3.82296 17.7604C3.49657 17.434 3.33337 17.0417 3.33337 16.5833V8.25C3.33337 7.79167 3.49657 7.39931 3.82296 7.07292C4.14935 6.74653 4.54171 6.58333 5.00004 6.58333H5.83337V4.91667C5.83337 3.76389 6.23962 2.78125 7.05212 1.96875C7.86462 1.15625 8.84726 0.75 10 0.75C11.1528 0.75 12.1355 1.15625 12.948 1.96875C13.7605 2.78125 14.1667 3.76389 14.1667 4.91667V6.58333H15C15.4584 6.58333 15.8507 6.74653 16.1771 7.07292C16.5035 7.39931 16.6667 7.79167 16.6667 8.25V16.5833C16.6667 17.0417 16.5035 17.434 16.1771 17.7604C15.8507 18.0868 15.4584 18.25 15 18.25H5.00004ZM11.1771 13.5938C11.5035 13.2674 11.6667 12.875 11.6667 12.4167C11.6667 11.9583 11.5035 11.566 11.1771 11.2396C10.8507 10.9132 10.4584 10.75 10 10.75C9.54171 10.75 9.14935 10.9132 8.82296 11.2396C8.49657 11.566 8.33337 11.9583 8.33337 12.4167C8.33337 12.875 8.49657 13.2674 8.82296 13.5938C9.14935 13.9201 9.54171 14.0833 10 14.0833C10.4584 14.0833 10.8507 13.9201 11.1771 13.5938ZM7.50004 6.58333H12.5V4.91667C12.5 4.22222 12.257 3.63194 11.7709 3.14583C11.2848 2.65972 10.6945 2.41667 10 2.41667C9.3056 2.41667 8.71532 2.65972 8.22921 3.14583C7.7431 3.63194 7.50004 4.22222 7.50004 4.91667V6.58333Z'
                    fill='#1C1B1F'
                />
            </mask>
            <g mask='url(#mask0_2397_28670)'>
                <rect
                    width='20'
                    height='20'
                    fill='#0F1321'
                    fillOpacity='0.32'
                />
            </g>
        </SvgIcon>
    );
});
